var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var SuperintendentBookingBusiness = function (storeContainer) {
    var store = storeContainer.store;
    var superintendentBookingStore = store.superintendentBookingStore;
    var propsConnect = {
        isPageLoading: superintendentBookingStore.isPageLoading,
        isDetailLoadFailed: superintendentBookingStore.isDetailLoadFailed,
        detail: superintendentBookingStore.detail,
        status: superintendentBookingStore.status,
        isBookable: superintendentBookingStore.isBookable,
        timeOptions: superintendentBookingStore.timeOptions,
        isTimesLoading: superintendentBookingStore.isTimesLoading,
        isTimesLoadFailed: superintendentBookingStore.isTimesLoadFailed,
        isMoreTimesOpen: superintendentBookingStore.isMoreTimesOpen,
        step: superintendentBookingStore.step,
        selectedSlot: superintendentBookingStore.selectedSlot,
        isSelectionMissing: superintendentBookingStore.isSelectionMissing,
        isBooking: superintendentBookingStore.isBooking,
        isJustBooked: superintendentBookingStore.isJustBooked,
        isRescheduling: superintendentBookingStore.isRescheduling,
        replacedBooking: superintendentBookingStore.replacedBooking,
        errorMessage: superintendentBookingStore.errorMessage,
    };
    var dispatchConnect = {
        init: superintendentBookingStore.init,
        retry: superintendentBookingStore.retry,
        toggleMoreTimes: superintendentBookingStore.toggleMoreTimes,
        selectSlot: superintendentBookingStore.selectSlot,
        goToConfirm: superintendentBookingStore.goToConfirm,
        backToPick: superintendentBookingStore.backToPick,
        book: superintendentBookingStore.book,
        startReschedule: superintendentBookingStore.startReschedule,
        cancelReschedule: superintendentBookingStore.cancelReschedule,
    };
    return __assign(__assign({}, propsConnect), dispatchConnect);
};
